import EntityType from 'types/ShoppingCart/EntityType';
import * as ShoppingCartList from 'types/ShoppingCart/ShoppingCartList';

export * as ShoppingCartContext from 'types/ShoppingCart/ShoppingCartContext';

export type Type = {
	carts: ShoppingCartList.Type;
	modalId: string | null;
	entityType: EntityType | null;
};

export function create(): Type {
	return {
		carts: [],
		modalId: null,
		entityType: null,
	};
}

export async function initialize() {
	return {
		...create(),
		carts: await ShoppingCartList.initialize(),
	};
}

export async function initializeWithoutDetails(obj: Type) {
	return {
		...create(),
		carts: await ShoppingCartList.initializeWithoutDetails(obj.carts),
	};
}
